import { AltLabel } from '../../TreeViewTypes';
import { DataNode, LabelContext } from '../../data_nodes/types';
import { LabelGenerator, DefaultLabelGenerator } from '../types';

/**
 * Generate default label for Owner nodes
 */
export const generateOwnerDefaultLabel: DefaultLabelGenerator = (
  dataNode: DataNode<any>,
  context: LabelContext,
): string => {
  // Owner data is typically a string representing the owner name
  if (typeof dataNode.data === 'string') {
    return dataNode.data;
  }

  // Fallback for object data
  if (dataNode.data && typeof dataNode.data === 'object') {
    if ('name' in dataNode.data && typeof dataNode.data.name === 'string') {
      return dataNode.data.name;
    }
    if ('ownerName' in dataNode.data && typeof dataNode.data.ownerName === 'string') {
      return dataNode.data.ownerName;
    }
  }

  return 'Unknown Owner';
};

/**
 * Generate alt labels for Owner nodes
 *
 * For now, just provides a single default option.
 * Could be extended later to show additional owner info.
 */
export const generateOwnerAltLabels: LabelGenerator = (
  dataNode: DataNode<any>,
  context: LabelContext,
): AltLabel[] => {
  const defaultLabel = generateOwnerDefaultLabel(dataNode, context);

  return [
    {
      key: 'default',
      selectOption: 'Default: Owner name',
      value: defaultLabel,
    },
  ];
};
